import React, { useEffect, useState } from 'react';
import { ToastContainer, toast } from "react-toastify";
import WithRouter from '../../_utility/WithRouter';
import api from '../../_utility/AxiosConfig';
import { useNavigate } from 'react-router';

const BookingConfirm = (props) => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const booking_id = props.params.booking_id;
    const [bookingInput, setBooking] = useState({
        'booking_id': booking_id,
        'payment_method': '',
        'errors': [],
        'processing': false
    });
    const [payable_amount, setpayableAmount] = useState(0);
    const [loading, setLoading] = useState(true);
    const [bookingInfo, setBookingInfo] = useState([]);

    useEffect(() => {
        api.post(`/api/booking/${booking_id}/details`, bookingInfo)
            .then(res => {
                setpayableAmount(res.data.payable_amount);
                setBookingInfo(res.data.data);
                setLoading(false);
            })
            .catch(error => {
                console.error("Error fetching data:", error);
                setLoading(false);
            });
    }, [booking_id]);

    const handlePayment = async (paymentMethod) => {
        setLoading(true);
        setBooking({ ...bookingInput, errors: [], payment_method: paymentMethod, processing: true });
        try {
            if(paymentMethod !== 'Bkash')
            {
                api.post('/api/sslcommerz/payment', {"booking_id":booking_id}).then(res => {
                    // console.log(res.data);
                    window.location.href = res.data.data;
                }).catch((error)=>{});
            }
            else
            {
                api.post(`/api/bkash/create-payment`, {
                    booking_id: booking_id,
                }).then(res => {
                    setBooking({ ...bookingInput, processing: false });
                    if (res.data && res.data.bkashURL) {
                        window.location.href = res.data.bkashURL;
                    } else {
                        setError("");
                        toast.error("Payment URL not received.");
                    }
                }).catch((error) => {
                    setBooking({ ...bookingInput, processing: false });
                    const errorMessage = error.response?.data?.message || 'Failed to initiate payment.';
                    toast.error(errorMessage);
                    setTimeout(() => {
                        navigate(`/booking/edit/${booking_id}`, {
                            state: {
                                booking_id: booking_id,
                            },
                        });
                    }, 500);
                });
            }
        }
        catch (err) {
            alert();
            setBooking({ ...bookingInput, processing: false });
            const errorMessage = (err.response?.data?.message || err.response?.data?.error) || "Something went wrong.";
            toast.error(errorMessage); // Display error message
        }
    };

    const parseAmount = (value) => {
        if (!value) return 0;
        return parseFloat(String(value).replace(/,/g, '')) || 0;
    };

    return (
        <>
            <ToastContainer />
            <section>
                <div className="inn-body-section">
                    <div className="container">
                        <div className="page-head">
                            <h2>Complete Your Payment</h2>
                            <div className="head-title">
                                <div className="hl-1"></div>
                                <div className="hl-2"></div>
                                <div className="hl-3"></div>
                            </div>
                            <p>Please review your payment details below. Proceed to make a secure payment and complete your booking.</p>
                        </div>
                        <div className='row'>
                            <div className='col-md-8 offset-md-2'>
                                {error && <p style={{ color: "red" }}>{error}</p>}


                                {!loading ? (
                                    <>
                                        <div className='shadow_card'>
                                            <div className='form-group mb-4'>

                                                <div className="text-center mb-4">
                                                    <h4 className="text-muted mb-3">Payable Amount</h4>
                                                    <h2 className="font-weight-bold">৳{parseAmount(payable_amount)}</h2>
                                                </div>
                                            </div>

                                            <div className="form-group text-center">
                                                    <h4 className='mb-4'>Pay With</h4>
                                                    <img 
                                                        src="/Bkash-Payment.png" 
                                                        onClick={() => handlePayment('Bkash')} 
                                                        style={{ height: '70px', width: 'auto', cursor: 'pointer' }} 
                                                        alt="Bkash Logo" 
                                                    />
                                                    
                                                    <h4 className="mt-3 mb-2">Or</h4>

                                                    <img 
                                                        src="/SSLCommerz-Pay-With-logo-All.png" 
                                                        onClick={() => handlePayment('SSLCommerz')} 
                                                        style={{ height: 'auto', width: '100%', cursor: 'pointer' }} 
                                                        alt="SSLCommerz Logo" 
                                                    />
                                                </div>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="row">
                                            <div className="col-md-12 shadow_card">
                                                <div className="ph-item border-0 p-0 m-0">
                                                    <div>
                                                        <div className="ph-row">
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-6 empty"></div>
                                                            <div className="ph-col-2"></div>
                                                            <div className="ph-col-10 empty"></div>
                                                            <div className="ph-col-8"></div>
                                                            <div className="ph-col-4 empty"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                        </div>
                                                    </div>
                                                    <div className="ph-col-12">
                                                        <div className="ph-row">
                                                            <div className="ph-col-10 big"></div>
                                                            <div className="ph-col-2 empty big"></div>
                                                            <div className="ph-col-4"></div>
                                                            <div className="ph-col-8 empty"></div>
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-6 empty"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-10 big"></div>
                                                            <div className="ph-col-2 empty big"></div>
                                                            <div className="ph-col-4"></div>
                                                            <div className="ph-col-8 empty"></div>
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-6 empty"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-10 big"></div>
                                                            <div className="ph-col-2 empty big"></div>
                                                            <div className="ph-col-4"></div>
                                                            <div className="ph-col-8 empty"></div>
                                                            <div className="ph-col-6"></div>
                                                            <div className="ph-col-6 empty"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                            <div className="ph-col-12"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default WithRouter(BookingConfirm);
